import { render } from "./elem-order-info.vue?vue&type=template&id=8109d934&ts=true"
import script from "./elem-order-info.vue?vue&type=script&lang=ts"
export * from "./elem-order-info.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__